var $54be727db6762488$exports = {};
$54be727db6762488$exports = {
    "maximum": `M\xe1ximo`,
    "minimum": `M\xednimo`
};


export {$54be727db6762488$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
